// @flow
import Component from './component';
import { connect } from 'react-redux';
import { getTranslationsLoading } from '~/core/state/translations/selectors';

const mapStateToProps = (state): { isLoading: boolean } => ({
    isLoading: getTranslationsLoading(state)
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/cookie-policy/index.js